import React from "react";
import { signUpInfoData } from "./data";
import { Icon } from "@accessdev/arc-ui-react";
import { selectors } from "@ReduxStore/reducers";
import { useSelector } from "react-redux";
import { useTransition, animated } from "react-spring";
import { usePreviousProps } from "@Src/hooks";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";
import LanguageSelectorMobile from "@Src/components/Language/LanguageSelectorMobile";
import Media from "react-media";
import { mediaBreakpoints } from "@accessdev/arc-ui-react/utils/js";

function InfoCard() {
  const memberKeyLabel = useSelector(selectors.getProgramMemberKeyLabel);
  const signUpStep = useSelector(selectors.getSignUpStep);
  const isMobileActive = !!useSelector(selectors.getMobileAppData);
  const isStandaloneTravel = useSelector(selectors.getIsStandaloneTravel);
  const previousSignUpStep = usePreviousProps(signUpStep);
  const [shouldTransition, setShouldTransition] = React.useState(false);
  const [signUpStepKey, setSignUpStepKey] = React.useState(signUpStep);
  const TRANSITION_TIME = 300;
  const helpNumber = useSelector(selectors.getHelpPhoneNumber);

  React.useEffect(() => {
    if (previousSignUpStep !== signUpStep) {
      setShouldTransition(false);
      setSignUpStepKey(previousSignUpStep);
      setTimeout(() => {
        setShouldTransition(true);
        setSignUpStepKey(signUpStep);
      }, TRANSITION_TIME);
    }
  }, [signUpStep, previousSignUpStep]);

  const headerTransitions = useTransition(shouldTransition, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: TRANSITION_TIME },
  });
  const bulletPointTransitions = useTransition(shouldTransition, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: TRANSITION_TIME },
  });

  return (
    <div className="AuthInfo-infoCard">
      <div className="AuthInfo-infoCard_content">
        <div>
          {headerTransitions(
            (styles, item) =>
              item && (
                <animated.h3
                  dangerouslySetInnerHTML={{
                    __html: signUpInfoData(isMobileActive, memberKeyLabel, isStandaloneTravel)[
                      signUpStepKey
                    ]?.header,
                  }}
                  className="t-title-large AuthInfo-infoCard_header"
                  style={styles}
                />
              ),
          )}
          {bulletPointTransitions(
            (styles, item) =>
              item && (
                <animated.div
                  style={{
                    ...styles,
                  }}
                  className="AuthInfo-infoCard_bulletPoints"
                >
                  {signUpInfoData(isMobileActive, memberKeyLabel, isStandaloneTravel)[
                    signUpStepKey
                  ]?.bulletPoints.map((point, i) => (
                    <div
                      key={`${i}+${point}`}
                      className="AuthInfo-infoCard_bulletPoint t-label-large"
                    >
                      <Icon
                        icon="fiber_manual_record"
                        className="AuthInfo-infoCard_bulletPointIcon"
                        mdTheme="outlined"
                        size="sm"
                      />
                      {typeof point !== "function" ? (
                        <span className="t-title-med" dangerouslySetInnerHTML={{ __html: point }} />
                      ) : (
                        point()
                      )}
                    </div>
                  ))}
                </animated.div>
              ),
          )}
        </div>
        <div className="AuthInfo-infoCard_helpNumber">
          <Media query={mediaBreakpoints.forPhoneOnly}>
            {(isPhone) => isPhone && <LanguageSelectorMobile />}
          </Media>
          <div className="t-body-med">
            <Trans>Need help? Call</Trans>{" "}
            <Media query={mediaBreakpoints.forPhoneOnly}>
              {(isPhone) =>
                isPhone ? (
                  <a aria-label={t`Need help? Click to call`} href={`tel:+${helpNumber}`}>
                    {helpNumber}
                  </a>
                ) : (
                  helpNumber
                )
              }
            </Media>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InfoCard;
